export const ALLOWED_RELATED_BUSINESS_RELATIONS = [
    'Matriz',
    'Filial',
    'Mesmo Sócio',
    'Empresa é Sócia',
];
